import { useEffect, useState } from 'react';
import { FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { chamarApi } from '../../nucleo/auth/cliente-api';
import { EmptyState } from '../../ui/EmptyState';
type Estado = {
  titulo: string;
  descricao: string;
  publicacoes: Array<{
    id: string;
    codigoConsulta: string;
    tipo: string;
    titulo: string;
    resumo: string;
    conteudo: string;
    linkReferencia: string | null;
    vigenciaInicio: string;
    vigenciaFim: string | null;
    versao: number;
  }>;
  revisao: string;
};
export function PortalPublicacoes() {
  const [e, setE] = useState<Estado | null>(null),
    [falha, setFalha] = useState(false);
  useEffect(() => {
    void chamarApi<{ state: Estado }>('/bff/v1/portal-publicacoes/state', { publica: true })
      .then((x) => setE(x.state))
      .catch(() => setFalha(true));
  }, []);
  if (falha)
    return (
      <EmptyState
        variant="error"
        title="Publicações temporariamente indisponíveis"
        description="Tente novamente em alguns instantes."
      />
    );
  if (!e)
    return (
      <div role="status" className="py-16 text-center text-muted-foreground">
        Carregando publicações vigentes…
      </div>
    );
  return (
    <section className="mx-auto max-w-5xl px-4 py-12 sm:px-6">
      <header className="mb-8">
        <h1 className="text-3xl font-bold">{e.titulo}</h1>
        <p className="mt-2 text-muted-foreground">{e.descricao}</p>
        <Link
          className="mt-3 inline-block text-link underline"
          to="/jornadas/j02/s03-consultar-publico"
        >
          Consultar situação pelo código público
        </Link>
      </header>
      {e.publicacoes.length === 0 ? (
        <EmptyState
          icon={FileText}
          title="Nenhuma publicação vigente"
          description="Não há conteúdo editorial dentro da vigência neste momento."
        />
      ) : (
        <div className="grid gap-5">
          {e.publicacoes.map((p) => (
            <article key={p.id} className="rounded-lg border bg-card p-5">
              <p className="text-xs font-medium text-muted-foreground">
                {p.tipo} · versão {p.versao}
              </p>
              <h2 className="mt-1 text-xl font-semibold">{p.titulo}</h2>
              {p.resumo && <p className="mt-2 text-muted-foreground">{p.resumo}</p>}
              <p className="mt-4 whitespace-pre-wrap">{p.conteudo}</p>
              {p.linkReferencia && (
                <a className="mt-4 inline-block text-link underline" href={p.linkReferencia}>
                  Consultar referência
                </a>
              )}
              <p className="mt-4 text-xs text-muted-foreground">
                Vigência desde {p.vigenciaInicio}
                {p.vigenciaFim ? ` até ${p.vigenciaFim}` : ''}
              </p>
              <p className="mt-2 text-xs font-medium">
                Código público: <span className="font-mono">{p.codigoConsulta}</span>
              </p>
            </article>
          ))}
        </div>
      )}
      <p className="mt-8 text-xs text-muted-foreground">Revisão pública {e.revisao.slice(0, 12)}</p>
    </section>
  );
}
